<template>
    <div
        id="list-subscriptionTypes-component"
        class="w-full h-full flex flex-col"
    >
        <custom-simple-select
            v-model="option"
            class="w-full"
            label="Tipo de suscripción"
            :options="subscriptionTypeOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { subscriptionTypesCodes } from "@/common/fields/platform-subscription-codes";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "SubscriptionTypeSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: ""
    }),
    computed: {
        subscriptionTypeOptions() {
            return Object.entries(subscriptionTypesCodes).map(
                ([key, value]) => ({
                    label: value,
                    value: key
                })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
